<script setup>
import { Card, Toggle, Hints, Suggestions } from '@components'
import DarkModeStore from '@o/store'
const { options } = DarkModeStore()
const { __ } = wp.i18n;


</script>
<template>
    <section>
        <Card borderless transparent class="gap-5" style="min-height: calc(100vh - 360px) !important">
            <Card>
                <Toggle v-model="options.admin_enabled">{{__('Enable Admin Dashboard Dark Mode', 'wp-dark-mode')}}</Toggle>
                <Hints>{{__('Turn it ON to enable dark mode on the WordPress dashboard', 'wp-dark-mode')}}</Hints>
            </Card>
            
            <Card>
                <Toggle v-model="options.admin_enabled_block_editor">{{__('Block Editor Dark Mode', 'wp-dark-mode')}}</Toggle>
                <Hints>{{__('Turn it ON to show dark mode switch in the block editor for toggling between dark and light mode.', 'wp-dark-mode')}}</Hints>
            </Card>


            <Card>
                <Toggle v-model="options.admin_enabled_classic_editor">{{__('Classic Editor Dark Mode', 'wp-dark-mode')}}</Toggle>
                <Hints>{{__('Turn it ON to show dark mode switch in the classic editor for toggling between dark and light mode.', 'wp-dark-mode')}}</Hints>
            </Card>
        </Card>
        <Suggestions paths="shortcode, excludes"></Suggestions>
    </section>
</template> 